import type { Session } from "next-auth";

/** Session user fields used on Graphify marketing (JWT + OAuth). */
export type LandingUser = {
  uuid?: string;
  email?: string | null;
  name?: string | null;
  image?: string | null;
  nickname?: string;
  avatar_url?: string;
  hasActiveSubscription?: boolean | null;
};

/**
 * Merge server-rendered session (from cookies) with client useSession to avoid
 * showing "Sign in" after OAuth while SessionProvider is still loading or when
 * uuid only exists on the server payload.
 */
export function resolveLandingAuthState(
  status: "loading" | "authenticated" | "unauthenticated",
  clientSession: Session | null | undefined,
  initialUser: LandingUser | null | undefined
): { user: LandingUser | undefined; signedIn: boolean } {
  const clientUser = clientSession?.user as LandingUser | undefined;
  const hasServerUser = Boolean(initialUser?.uuid);
  const hasClientUser = Boolean(clientUser?.uuid);
  const user =
    hasServerUser || hasClientUser
      ? {
          ...initialUser,
          ...clientUser,
          uuid: clientUser?.uuid ?? initialUser?.uuid,
          email: clientUser?.email ?? initialUser?.email,
          name: clientUser?.name ?? initialUser?.name,
          image: clientUser?.image ?? initialUser?.image,
          nickname: clientUser?.nickname ?? initialUser?.nickname,
          avatar_url: clientUser?.avatar_url ?? initialUser?.avatar_url,
          hasActiveSubscription:
            clientUser?.hasActiveSubscription ?? initialUser?.hasActiveSubscription,
        }
      : undefined;

  const signedIn = Boolean(user?.uuid);

  return { user, signedIn };
}
